// typeahead is not easily scrolled through with arrow keys unless if the list allows scrolling
// otherwise, when you arrow through the items and go off the page, then you can't see what is selected
// and the page doesn't scroll properly
// this all comes from how angular-ui-bootstrap handles the keydown events:
// (it expects the parent node to be in a scrollable element, like the body)
// target = popUpEl.find('li')[scope.activeIdx];
// target.parentNode.scrollTop = target.offsetTop;

angular.module('aprima-core-ui').factory('setTypeaheadPopupHeight', ['findTypeahead', 'debounce', '$parse', '$window', function (findTypeahead, debounce, $parse, $window) {
    'use strict';

    // this is the debounce time that angular-ui-bootstrap uses
    var heightDebounceTime = 200;

    // the new attribute I'm defining to allow you to give a max height to search results
    // search results will be scrollable themselves (not just the window scrolling)
    // default height is 5px less than the height of the screen
    var typeaheadPopupMaxHeight = 'ap-typeahead-popup-max-height';

    // to use this attribute you must also add 'ap-typeahead-popup-max-height'
    // this attribute will allow you to specify the id of the containing element
    // the dropdown will not exceed that container
    var typeaheadParent = 'ap-typeahead-popup-parent';

    return setTypeaheadPopupHeight;

    function setTypeaheadPopupHeight(popupScope, popupElement, typeaheadElement) {
        if(!popupScope || !popupElement) {
            return;
        }
        
        typeaheadElement = typeaheadElement || findTypeahead(popupElement);
        if(!typeaheadElement || !typeaheadElement[0] || !typeaheadElement[0].hasAttribute(typeaheadPopupMaxHeight)) {
            return;
        }

        // evaluate on outer scope
        var maxHeight = parseFloat(popupScope.$parent.$parent.$eval(typeaheadElement.attr(typeaheadPopupMaxHeight)));
        
        popupElement.css('overflow-y', 'auto');
        if(maxHeight > 1) {
            popupElement.css('max-height', maxHeight + 'px');
            return;
        }

        var windowSelector = $($window);
        var parentContainerElem;
        var parentElemId = typeaheadElement.attr(typeaheadParent);
        if(parentElemId) {
            var id = $parse(parentElemId)(popupScope.$parent);
            parentContainerElem = $(document).find('#' + id);
        }
        updateHeight();
        var debouncedUpdateHeight = debounce(heightDebounceTime, updateHeight);
        windowSelector.on('resize', debouncedUpdateHeight);

        var parentElement = popupElement.parent()[0];
        var observer = new MutationObserver(updateHeight);
        observer.observe(parentElement, {attributes: false, childList: true, subtree: true});

        popupScope.$on('$destroy', function(){
            windowSelector.off('resize', debouncedUpdateHeight);
            observer.disconnect();
        });

        function updateHeight() {
            var availableHeight;
            var top = popupElement.offset().top;
            if (parentContainerElem && parentContainerElem.length) {
                availableHeight = parentContainerElem.height();
                top = top - parentContainerElem.offset().top;
            } else {
                availableHeight = windowSelector.height();
            }
            //minus 5 to make sure scroll bars are gone
            var updatedHeight = availableHeight - top - 5;
            popupElement.css('max-height', updatedHeight + 'px');
        }
    }
}]);
